"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconSearchHeavy = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M30.4 52.86a23.09 23.09 0 1 1 23.09-23.1 23.12 23.12 0 0 1-23.09 23.1zm0-38.46a15.37 15.37 0 1 0 15.37 15.36A15.39 15.39 0 0 0 30.4 14.39z"
  }), _react["default"].createElement("path", {
    d: "M58.83 63.33a3.85 3.85 0 0 1-2.73-1.13L40.61 46.7a3.86 3.86 0 1 1 5.46-5.46l15.49 15.5a3.86 3.86 0 0 1-2.73 6.59z"
  })),
  height: undefined,
  width: undefined
});
IconSearchHeavy.displayName = 'IconSearchHeavy';
var _default = IconSearchHeavy;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/search-heavy.js
// module id = 126
// module chunks = 0